import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

const state = {
  isLogin: 0,   // 是否登录
  userInfo: {}, // 用户信息
}
const mutations = {
  getUserInfo(state,info){
    state.userInfo = info;
    state.isLogin = 1;
  },
  deleteUserInfo(state){    
    state.userInfo = ''
    state.isLogin = 0;
  }
}
const actions = {
  // ...some code
  asyncUserInfo(context,info){
    context.commit('getUserInfo',info)
  },
  asyncDeleteUserInfo(context){    
    context.commit('deleteUserInfo')
  }  
}

export default new Vuex.Store({
    state,
    actions,
    mutations
})



// WEBPACK FOOTER //
// ./src/store/index.js